import React from 'react';
import Typography from '@mui/material/Typography';

import FileLoaderAnimation from '../../assets/animations/FileLoaderAnimation';

const FirstLoadMessage = () => (
  <>
    <FileLoaderAnimation />
    <Typography variant="h4" paragraph>
      Estamos cargando tus facturas
    </Typography>
    <Typography variant="body1" paragraph>
      Recarga la página para actualizar.
    </Typography>
  </>
);

export default FirstLoadMessage;
